import { Navigate, Outlet, useRoutes } from "react-router-dom";

import { GuestGuard } from "@app/guard";
import AuthGuard from "@app/guard/AuthGuard";
import {
  ForgotPasswordPage,
  LoginPage,
  SignUpPage,
  UpdatePasswordPage,
} from "@app/modules/auth";
import { HomePage } from "@app/modules/home";
import { CategoryPage } from "@app/modules/categories/view/category-page";
import { TestDriveProcessPage, UserInfo } from "@app/modules/test-drive-process";
import { BookNowPage } from "@app/modules/buy";
import { ProductListPage } from "@app/modules/product-list-page";
import { ProductDetail } from "@app/modules/product-detail";
import { EditProfile } from "@app/modules/my-profile";
import { Navbar } from "@app/components";
import { LandingPage } from "@app/modules/landing";
import { SellCar } from "@app/modules/sellCar";
import { CheckValuation } from "@app/modules/check-valuation";
import { Wishlist } from "@app/modules/wishlist";

import { PATH_AUTH, PATH_DASHBOARD } from "./paths";
import * as Configs from "../configs";
import { MyOrders } from "@app/modules/my-orders";
import { BeAnInvestor } from "@app/modules/beAnInvestor";

// ----------------------------------------------------------------------

export function Router() {
  return useRoutes([
    {
      path: "/",
      element: <LandingPage />,
    },

    // {
    //   element: (
    //     <GuestGuard>
    //       <Outlet />
    //     </GuestGuard>
    //   ),
    //   children: [
    //     {
    //       path: PATH_AUTH.login,
    //       element: <HomePage />,
    //     },
    //     {
    //       path: PATH_AUTH.signUp,
    //       element: <SignUpPage />,
    //     },
    //     {
    //       path: PATH_AUTH.forgotPassword,
    //       element: <ForgotPasswordPage />,
    //     },
    //     {
    //       path: PATH_AUTH.updatePassword,
    //       element: <UpdatePasswordPage />,
    //     },
    //     // { path: PATH_DASHBOARD.landing, element: <LandingPage /> },
    //   ],
    // },
    {
      path: PATH_DASHBOARD.root,
      element: <Navbar />,
      children: [
        // {
        //   element: <Navigate to={Configs.PATH_AFTER_LOGIN} replace />,
        //   index: true,
        // },
        { path: PATH_DASHBOARD.home, element: <HomePage /> },
        { path: PATH_DASHBOARD.categrey, element: <CategoryPage /> },
        { path: PATH_DASHBOARD.sellCar, element: <SellCar /> },
        { path: PATH_DASHBOARD.checkValuation, element: <CheckValuation /> },
        { path: PATH_DASHBOARD.beAnInvestor, element: <BeAnInvestor /> },
        { path: PATH_DASHBOARD.wishlist, element: <Wishlist /> },

        {
          path: PATH_DASHBOARD.testDriveProcess,
          element: <UserInfo />,
        },
        {
          path: `${PATH_DASHBOARD.bookNow}/:buyProductId`,
          element: <BookNowPage />,
        },
        { path: PATH_DASHBOARD.productListPage, element: <ProductListPage /> },
        {
          path: `${PATH_DASHBOARD.productDetail}/:productId`,
          element: <ProductDetail />,
        },
        { path: PATH_DASHBOARD.myProfile, element: <EditProfile /> },
        { path: PATH_DASHBOARD.myOrders, element: <MyOrders /> },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/" replace />,
    },
  ]);
}
